import { Injectable } from '@angular/core';
import { HandoverTakeoverListParams } from '@app/domain';
import { HandoverTakeoverTemplate } from '@app/domain/entities/handover-takeover.entity';
import { HandoverTakeoverRepository } from '@app/domain/repositories/handover-takeover.repository';
import { PaginatedResponse } from '@app/shared/models/global.model';
import { Observable } from 'rxjs';
import { HandoverTakeoverService } from '../api-clients/handover-takeover.service';
import { VesselHotoService } from '../api-clients/vessel-hoto.service';

@Injectable()
export class HandoverTakeoverRepositoryImpl implements HandoverTakeoverRepository {
  constructor(
    private readonly _handoverTakeoverService: HandoverTakeoverService,
    private readonly _vesselHotoService: VesselHotoService
  ) {}

  getList(
    params: HandoverTakeoverListParams
  ): Observable<PaginatedResponse<HandoverTakeoverTemplate>> {
    return this._handoverTakeoverService.getList(params);
  }

  getDetail(id: number): Observable<HandoverTakeoverTemplate> {
    return this._handoverTakeoverService.getDetail(id);
  }

  getClientCodes(): Observable<string[]> {
    return this._handoverTakeoverService.getClientCodes();
  }

  getVisibility(): Observable<{
    isNomVisible: boolean;
    isPsVisible: boolean;
    clientCodes: string[];
  }> {
    return this._vesselHotoService.getVisibility();
  }

  updateVisibility(body: {
    shouldShowNom: boolean;
    shouldShowPS: boolean;
    clientCodes: string[];
  }): Observable<void> {
    return this._vesselHotoService.updateVisibility(body);
  }
}
